"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubjectTypeDetail = exports.SubjectType = void 0;
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const GlobalStateProvider_1 = require("../../../../../GlobalStateProvider");
const common_1 = require("../../../../../common");
// 과목 리스트
const subjectList = [
    { id: 'select', title: 'common.select' },
    { id: 'korean', title: 'assignment.korean' },
    { id: 'english', title: 'assignment.english' },
    { id: 'math', title: 'assignment.math' },
    { id: 'history', title: 'assignment.history' },
    { id: 'character', title: 'assignment.character' },
];
/**
 * 출제 유형 선택 dropdown
 *  - 출제 유형 (OMR 기본형, OMR 자유형, 첨부파일, 설문) 선택
 */
exports.SubjectType = react_1.default.memo(({ questionTypeId, subject, setSubject, }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const { isDesktop, isTablet } = (0, GlobalStateProvider_1.useGlobalState)();
    const isShowSubject = (0, react_1.useMemo)(() => (questionTypeId === 'OMR' && subject ? true : false), [questionTypeId, subject]);
    if (!isShowSubject)
        return null;
    return (react_1.default.createElement("div", { className: "field-global-001" },
        react_1.default.createElement("div", { className: "task-label" }, t('assignment.selectSubject')),
        react_1.default.createElement("div", { className: "fext-field" },
            react_1.default.createElement(common_1.DropDown, { className: 'dropdown-popup', value: subject, styles: {
                    dropWrap: {
                        flex: 1,
                    },
                }, list: subjectList, setDropValue: setSubject }))));
});
/**
 *  화면에 보이는 과목 detail 업데이트 (subject detail)
 *  -> ex) 국어 - 공통, 선택 - 언어와매체, 선택 - 화법과 작문
 */
exports.SubjectTypeDetail = react_1.default.memo(({ checkSubjectList, questionTypeId, originalSubjectId, subjectId, scoreBlank, evalList, setScoreBlank, setEvalList, }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const [list, setList] = react_1.default.useState(evalList);
    const getSubjectDetailData = (subjectId) => {
        let data;
        switch (subjectId) {
            case 'korean':
                data = [
                    { id: '1', title: '공통', checked: false },
                    { id: '선택 - 언어와매체', title: '선택 - 언어와매체', checked: false },
                    { id: '선택 - 화법과 작문', title: '선택 - 화법과 작문', checked: false },
                ];
                break;
            case 'math':
                data = [
                    { id: '2', title: '공통', checked: false },
                    { id: '선택 - 확률과 통계', title: '선택 - 확률과 통계', checked: false },
                    { id: '선택 - 미적분', title: '선택 - 미적분', checked: false },
                    { id: '선택 - 기하', title: '선택 - 기하', checked: false },
                ];
                break;
            case 'english':
                data = [
                    { id: '듣기', title: '듣기', checked: false },
                    { id: '읽기', title: '읽기', checked: false },
                ];
                break;
            default:
                data = undefined;
        }
        return data;
    };
    const handlerSubjectList = subjectList => {
        if (subjectId === originalSubjectId) {
            const choiceSubject = subjectList &&
                subjectList.map(item => {
                    const isExist = checkSubjectList.find(i => i === item.title);
                    return { ...item, checked: isExist ? true : false };
                });
            setList(choiceSubject);
        }
        else {
            setList(subjectList &&
                subjectList.map(item => {
                    const isExist = (evalList && evalList?.find(i => i.id === item.id)?.checked) ||
                        false;
                    return {
                        ...item,
                        checked: isExist,
                    };
                }));
        }
    };
    /**
     * 과목이 변경되는 경우
     *  -> 화면에 보이는 과목 detail 업데이트 (subject detail)
     */
    react_1.default.useEffect(() => {
        if (subjectId === 'history' || subjectId === 'character') {
            setList([
                {
                    id: t(`assignment.${subjectId}`),
                    title: t(`assignment.${subjectId}`),
                    checked: true,
                },
            ]);
            return;
        }
        else {
            handlerSubjectList(getSubjectDetailData(subjectId));
        }
    }, [subjectId, originalSubjectId, checkSubjectList]);
    // (onClick) 평가 항목 업데이트
    const handlerUpdateEvalItem = (id, checked) => {
        setList(prevList => prevList.map(item => {
            if (item.id === id)
                return { ...item, checked };
            return item;
        }));
    };
    // (onClick) 전체 배점 공란 업데이트
    const updateScoreBlank = (id, checked) => {
        setScoreBlank(checked);
    };
    /**
     * 선택된 과목 상세만 들어가도록 수정
     */
    react_1.default.useEffect(() => {
        setEvalList(list);
    }, [list]);
    return (questionTypeId === 'OMR' && (react_1.default.createElement("div", { className: "field-global-001", style: { alignItems: 'flex-start' } },
        react_1.default.createElement("div", { className: "task-label" }, t('assignment.evalItem')),
        react_1.default.createElement("div", { className: "fext-field", style: { flexDirection: 'column', alignItems: 'flex-start' } },
            subjectId !== 'history' &&
                subjectId !== 'character' &&
                list &&
                list.length > 0 && (react_1.default.createElement(common_1.CheckBox, { className: "assignment-checkbox-txt", iconSize: 24, list: list, handlerCheck: handlerUpdateEvalItem })),
            react_1.default.createElement(common_1.CheckBoxElement, { id: "scoreBlank", className: "scoreBlank", title: "assignment.scoreBlank", style: { gap: 6 }, checked: scoreBlank, handlerCheck: updateScoreBlank })))));
});
